import announcer from './aria-announcer';

document.addEventListener('DOMContentLoaded', () => {
    const maxVisible = 8;

    document.querySelectorAll('.group-filters').forEach((group) => {
        const list = group.querySelector('.accordion-panel');
        if (!list) return;

        const items = [...list.querySelectorAll('li:not(.filters-toggle-item)')];
        const toggleBtn = group.querySelector('.filters-toggle');

        if (!toggleBtn) return;

        if (items.length <= maxVisible) {
            toggleBtn.style.display = 'none';
            return;
        }

        if (toggleBtn.dataset.bound === 'true') return;
        toggleBtn.dataset.bound = 'true';

        items.slice(maxVisible).forEach((li) => {
            const liElement = li;
            liElement.style.display = 'none';
        });

        const hiddenCount = items.length - maxVisible;
        toggleBtn.textContent = `Voir plus (${hiddenCount})`;

        toggleBtn.addEventListener('click', () => {
            const hidden = items.slice(maxVisible).some((li) => li.style.display === 'none');
            if (hidden) {
                items.slice(maxVisible).forEach((li) => {
                    const liElement = li;
                    liElement.style.display = 'list-item';
                });
                toggleBtn.textContent = 'Voir moins';
                announcer.announce(`Affichage de ${hiddenCount} filtres supplémentaires.`);
            } else {
                items.slice(maxVisible).forEach((li) => {
                    const liElement = li;
                    liElement.style.display = 'none';
                });
                toggleBtn.textContent = `Voir plus (${hiddenCount})`;
                announcer.announce(`${hiddenCount} filtres ont été masqués.`);
            }
        });
    });

    const openBtn = document.querySelector('.btn-mobile-filters');
    const closeBtn = document.querySelector('.btn-filtres-close');
    const facets = document.querySelector('.search-aside');

    if (!openBtn || !closeBtn || !facets) return;

    openBtn.addEventListener('click', () => {
        facets.classList.add('active');
    });

    closeBtn.addEventListener('click', () => {
        facets.classList.remove('active');
    });
});
